import { render, staticRenderFns } from "./priceCostOption.vue?vue&type=template&id=a740646c&scoped=true&"
import script from "./priceCostOption.vue?vue&type=script&lang=js&"
export * from "./priceCostOption.vue?vue&type=script&lang=js&"
import style0 from "./priceCostOption.vue?vue&type=style&index=0&id=a740646c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a740646c",
  null
  
)

export default component.exports